<template>
    <div class="csv-form">
        <h3>Upload CSV File</h3>
        <hr>
        <Attachment
            :fileName="fileName"
            :error="error"
            :progress="progress"
            accept=".csv"
            @drop="handleFile"
            @upload="handleFile"
        />
        <hr>
        <div class="actions">
            <AppButton modifier="small-danger" @click="$emit('close')">
                Close
            </AppButton>
            <AppButton modifier="small-primary" @click="$emit('confirm')" :disabled="!fileName || error">
                Confirm
            </AppButton>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton'
import Attachment from '@/components/Attachment'
export default {
	props: {
		progress: {
			type: [Number, String],
			default: 0
		}
	},
	data () {
		return {
			fileName: '',
			error: false
		}
	},
	methods: {
		handleFile (e) {
			this.error = false
			const files = e.target.files || e.dataTransfer.files
			if (!files.length) return
			const name = files[0].name
			if (name.split('.').pop().toLowerCase() !== 'csv') {
				this.error = true
				return
			}
			this.fileName = name
			this.$emit('upload', files)
		}
	},
	components: {
		AppButton,
		Attachment
	}
}
</script>

<style lang="scss" scoped>
.data-container {
    height: 300px;
    align-items: center;
}

.csv-form {
    width: 380px;
}

h3 {
    color: $primary;
}

::v-deep .upload--details {
    flex: 1;
}

.actions {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;

    .app-button:not(:last-of-type) {
        margin-right: 5px;
    }
}
</style>
